import bcrypt from 'bcryptjs';
import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import useAuth from '../../lib/hooks/useAuth';
import arrow from '../../icons/arrow-return.svg';
import useProtected from '../../lib/hooks/useProtected';
import styles from '../../styles/pages/Form-coachs-back.module.scss';

const AjoutCoachBack = () => {
  useProtected();
  const [coach, setCoach] = useState({});
  const [studiosList, setStudios] = useState([]);
  const [selectedFile, setFile] = useState(null);
  const { user } = useAuth();

  const navigate = useNavigate();

  const fetchStudios = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_REQUEST_URL}/studios`,
      {
        method: 'GET',
      },
    );
    if (response.ok) {
      const data = await response.json();
      setStudios(data['hydra:member']);
    }
  };

  const handleChange = (event) => {
    setCoach((state) => ({ ...state, [event.target.name]: event.target.value }));
  };

  const fileSelectedHandler = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let picture = '';

    if (selectedFile !== null) {
      picture = selectedFile.name;
    }
    const studios = studiosList.reduce((previous, current) => {
      if (event.target[current.name].checked) {
        return [...previous, current['@id']];
      }
      return previous;
    }, []);

    const salt = bcrypt.genSaltSync(10);
    const makeid = (length) => {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i += 1) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    };
    const generatedPassword = makeid(10);
    const hashedPassword = bcrypt.hashSync(generatedPassword, salt);

    const body = JSON.stringify({
      email: coach.email,
      lname: coach.lname,
      fname: coach.fname,
      address: coach.address,
      birthDate: coach.birthDate,
      phone: coach.phone,
      photo: picture,
      password: hashedPassword,
      description: coach.description,
      seances: [],
      studios,
      roles: ['ROLE_COACH'],
    });

    const response = await fetch(`${process.env.REACT_APP_REQUEST_URL}/coaches`, {
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.token}`,
      },
    });
    if (response.ok) {
      if (selectedFile !== null) {
        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);

        reader.onload = async (e) => {
          const myBody = JSON.stringify({
            file: e.target.result,
            name: selectedFile.name,
          });

          const responseUpload = await fetch(
            `${process.env.REACT_APP_UPLOAD_URL}`,
            {
              method: 'POST',
              body: myBody,
              headers: {
                'Content-Type': 'application/json',
              },
            },
          );
          if (responseUpload.ok) {
            navigate('/back/liste-coachs');
          }
        };
      }
      const bodyMailCoach = JSON.stringify({
        fname: coach.fname,
        email: coach.email,
        password: generatedPassword,
      });
      const responseMailCoach = await fetch(
        `${process.env.REACT_APP_MAIL_URL}/ajout-coach`,
        {
          method: 'POST',
          body: bodyMailCoach,
        },
      );
      if (responseMailCoach.ok) {
        alert('Le coach que vous venez d\'ajouter a reçu un mail avec ses informations de connexion.');
      } else {
        alert('Une erreur s\'est produite lors de l\'envoi du mail au coach.');
      }
      navigate('/back/liste-coachs');
    }
  };

  useEffect(() => {
    fetchStudios();
  }, []);

  return (
    <>
      <Link to="/back/liste-coachs" className={styles.lien}>
        <img src={arrow} alt="arrow" className={styles.image} />
        <p>Retourner à la liste des coachs</p>
      </Link>
      <h1 className={styles.titre}>Ajout d&apos;un coach</h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.nomComplet}>
          <label className={styles.label} htmlFor="lname">
            <p>Nom</p>
            <input className={styles.champ} type="text" name="lname" onChange={handleChange} required />
          </label>
          <label className={styles.label} htmlFor="fname">
            <p>Prénom</p>
            <input className={styles.champ} type="text" name="fname" onChange={handleChange} required />
          </label>
        </div>
        <div className={styles.naissanceTelephone}>
          <label className={styles.label} htmlFor="birthDate">
            <p>Date de naissance</p>
            <input className={styles.champ} type="date" name="birthDate" onChange={handleChange} required />
          </label>
          <label className={styles.label} htmlFor="phone">
            <p>Numéro de téléphone</p>
            <input className={styles.champ} type="text" name="phone" onChange={handleChange} required />
          </label>
        </div>
        <div className={styles.adresse}>
          <label className={styles.label} htmlFor="address">
            <p>Adresse</p>
            <input className={styles.champ} type="text" name="address" onChange={handleChange} required />
          </label>
        </div>
        <div className={styles.email}>
          <label className={styles.label} htmlFor="email">
            <p>Email</p>
            <input className={styles.champ} type="email" name="email" onChange={handleChange} required />
          </label>
        </div>
        <div className={styles.photo}>
          <label className={styles.label} htmlFor="photo">
            <p>Photo</p>
            <div className={styles.fileInput}>
              {selectedFile ? selectedFile.name : 'Choisissez un fichier.'}
              <input type="file" name="photo" id="photo" onChange={fileSelectedHandler} />
            </div>
          </label>
          <label className={styles.label} htmlFor="description">
            <p>Description</p>
            <textarea className={styles.champ} name="description" onChange={handleChange} required />
          </label>
        </div>
        <p>Studios associés</p>
        <ul className={styles.studios}>
          {studiosList.map((studio) => (
            <li key={studio.id}>
              <label className={styles.label} htmlFor={studio.name}>
                <input
                  type="checkbox"
                  name={studio.name}
                  id={studio.name}
                />
                <p>{studio.name}</p>
              </label>
            </li>
          ))}
        </ul>
        <input className={styles.button} type="submit" />
      </form>
    </>
  );
};
export default AjoutCoachBack;
